import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import ContentFrom from "../components/contentfrom";

function Gettouch(props) {
    return (
        <div className="gettouch p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
                        <div className="example" data-text="Conect">
                            <h2>Let’s Discuss Your Project</h2>
                        </div>
                        <p>Start your journey to protect your intellectual assets with TekRevol's cutting-edge IP protection services. Our relentless commitment to excellence, supported by a team of dedicated specialists helps you secure your intellectual property. Whether it's distinct protection needs or delivering tailored solutions, TekRevol stands as your reliable partner in the realm of safeguarding innovation. Let’s begin a discussion about your intellectual property today and figure out a way for sustainability in the ever-evolving landscape of intellectual assets.</p>
                    </Col>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto offset-lg-1">
                        <ContentFrom/>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Gettouch;